/**
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

function validateName(value, errorMessages = {}) {
  if (!value) {
    return errorMessages && errorMessages.name && errorMessages.name.required;
  }

  if (value.length < 2) {
    return errorMessages && errorMessages.name && errorMessages.name.tooShort;
  }

  if (value.length > 64) {
    return errorMessages && errorMessages.name && errorMessages.name.tooLong;
  }

  if (!/^[^!$%#^&@*()_+|~={}[\]:";<>?/0-9]+$/.test(value)) {
    return errorMessages && errorMessages.name && errorMessages.name.invalid;
  }

  return null;
}

function validateEmail(value, errorMessages = {}) {
  if (!value) {
    return errorMessages && errorMessages.email && errorMessages.email.required;
  }

  if (!/\S+@\S+\.\S+/.test(value)) {
    return errorMessages && errorMessages.email && errorMessages.email.invalid;
  }

  if (value.length > 140) {
    return errorMessages && errorMessages.email && errorMessages.email.tooLong;
  }

  return null;
}

function validatePhone(value, errorMessages = {}) {
  if (!value) {
    return null;
    // return errorMessages && errorMessages.phone && errorMessages.phone.required;
  }

  if (!/^(\+47)?[4|9]([- ]*[0-9]){7}$/.test(value)) {
    return errorMessages && errorMessages.phone && errorMessages.phone.invalid;
  }

  return null;
}

function validateMessage(value, errorMessages = {}) {
  if (!value) {
    return null;
    // return (
    //   errorMessages && errorMessages.message && errorMessages.message.required
    // );
  }

  if (value.length < 2) {
    return (
      errorMessages && errorMessages.message && errorMessages.message.tooShort
    );
  }

  if (value.length > 2048) {
    return (
      errorMessages && errorMessages.message && errorMessages.message.tooLong
    );
  }

  return null;
}

function validateAccept(value, errorMessages = {}) {
  if (!value) {
    return (
      errorMessages && errorMessages.accept && errorMessages.accept.required
    );
  }

  return null;
}

export const validators = {
  firstName: validateName,
  lastName: validateName,
  email: validateEmail,
  phone: validatePhone,
  message: validateMessage,
  accept: validateAccept,
};

export function createValidator(errorMessages) {
  return async function(values) {
    const errors = {};

    Object.keys(values).forEach(key => {
      const fn = validators[key];

      if (!fn || typeof fn !== 'function') {
        return;
      }

      const err = fn(values[key], errorMessages);

      if (err) {
        errors[key] = err;
      }
    });

    return errors;
  };
}
